import React, { Fragment, JSX } from 'react';
import { InputText } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import { FormInputNamePayment } from '../types';

interface StateProps {
  formData: FormData;
  formErrors: FormErrors;
}

interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
}

type Props = StateProps & DispatchProps;

export const PaymentValueContent: React.FC<Props> = ({
  formData,
  onChangeFormInput,
  formErrors,
}): JSX.Element => (
  <Fragment>
    <h2 className="font-dmsans font-normal text-neutro-b-400 text-[28px]">
      Informações de pagamento
    </h2>
    <p className="font-dmsans text-base font-normal text-neutro-w-600 leading-[28px]">
      Preencha o valor a ser pago
    </p>
    <div className="md:w-[500px] mt-[20px]">
      <form onSubmit={e => e.preventDefault()}>
        <div className="mb-[20px]" id="divCPF">
          <InputText
            name="paymentFractionalValue"
            label="Valor"
            placeholder="R$ 0,00"
            className={`appearance-none w-full
                          rounded-md text-heading leading-tight focus:outline-none
                          focus:shadow-outline text-xs font-dmsans font-normal`}
            maxLength={14}
            value={formData[FormInputNamePayment.paymentFractionalValue]}
            onChange={e =>
              onChangeFormInput(FormInputNamePayment.paymentFractionalValue)(e.target.value)
            }
            error={formErrors.paymentFractionalValue && formErrors.paymentFractionalValue[0]}
          />
        </div>
      </form>
    </div>
  </Fragment>
);
